import React from 'react';

export interface TabMenuItemProps {
  id: string;
  label: string;
  count?: number;
  isActive: boolean;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  /** Highlight tab when search has matches in this queue (AXISREF350). */
  hasSearchMatches?: boolean;
}

export const TabMenuItem: React.FC<TabMenuItemProps> = ({
  id,
  label,
  count,
  isActive,
  onClick,
  disabled = false,
  className = '',
  hasSearchMatches = false,
}) => {
  return (
    <button
      id={id}
      className={`tab-menu-item ${isActive ? 'active' : ''} ${hasSearchMatches ? 'has-search-matches' : ''} ${className}`}
      onClick={onClick}
      disabled={disabled}
      type="button"
    >
      {label}
      {count !== undefined && count !== null && (
        <span className="tab-menu-count"> ({count})</span>
      )}
    </button>
  );
};

